import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./Translation/i18n";
import App from "./App";
import store from "./redux/store/Store";
import { CssBaseline, ThemeProvider } from "@mui/material";
import mwTheme from "./mwtheme";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={mwTheme}>
    <CssBaseline enableColorScheme />
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>
);
reportWebVitals();